function getMinPrice(productVariantPrices, productVariantCompareAtPrices) {
  if (
    productVariantPrices.length !== 0 &&
    productVariantCompareAtPrices.length !== 0
  ) {
    const minElement = productVariantPrices.reduce((min, current) =>
      current.value[0] < min.value[0] ? current : min
    );

    const matchedItem = productVariantCompareAtPrices.find(
      (item) => item.variationId === minElement.variationId
    );
    return { price: matchedItem, sellingPrice: minElement };
  } else {
    return;
  }
}
window.onWizzyScriptLoaded = function () {
  const searchInputs = document.querySelectorAll(".wizzy-search-input");
  searchInputs.forEach((input) => {
    input.addEventListener("focus", function () {
      document.body.classList.add("wizzy-custom-header");
    });

    input.addEventListener("blur", function () {
      document.body.classList.remove("wizzy-custom-header");
    });
  });

  // Replacing default template
  replaceTemplate("wizzy-search-results-product");
  // replaceTemplate("wizzy-search-results");
  // replaceTemplate("wizzy-search-empty-results");
  replaceTemplate("wizzy-search-wrapper");
  replaceTemplate("wizzy-autocomplete-topproducts");
  replaceTemplate("wizzy-autocomplete-suggestions");
  replaceTemplate("wizzy-common-select");
  replaceTemplate("wizzy-search-summary");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.search.configs.general.minQueryLength = 1;
      // window.wizzyConfig.common.isLazyInit = true;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")

      payload.forEach((product) => {
        product.showSelectedVarint = "";
        product.subTitleOne = "";
        product.orderable = true;

        product.petitPrix = false;
        product.labelPlanteBleue = false;
        product.planteSuspendue = false;
        product.exclusivité = false;
        let productVariantPrices = [];
        let productVariantCompareAtPrices = [];
        if (product.attributes) {
          product.attributes.forEach((attribute) => {
            if (attribute.id === "product_Title") {
              if (attribute.values[0].value[0]) {
                product.showSelectedVarint = attribute.values[0].value[0];
                // console.log(attribute.values[0].value[0], ' <---- ')
              }
            }
            if (attribute.id === "product_superbullet_global") {
              if (attribute.values[0].value[0]) {
                product.subTitleOne = attribute.values[0].value[0];
              }
            }

            if (attribute.id === "product_Spécifications_tags") {
              if (attribute.values[0].value.length > 0) {
                attribute.values[0].value.forEach((item) => {
                  if (item === "Petit prix") {
                    product.petitPrix = true;
                  }
                  if (item === "Label Plante Bleue") {
                    product.labelPlanteBleue = true;
                  }
                  if (item === "Plante suspendue") {
                    product.planteSuspendue = true;
                  }
                  if (item === "Exclusivité") {
                    product.exclusivité = true;
                  }
                });
              }
            }

            if (attribute.id === "product_variant_prices") {
              if (attribute.values.length > 1) {
                productVariantPrices = attribute.values;
              }
            }

            if (attribute.id === "product_variant_compare_at_prices") {
              if (attribute.values.length > 1) {
                productVariantCompareAtPrices = attribute.values;
              }
            }

            if (attribute.id === "product_Orderable_tags") {
              if (attribute.values[0].value[0]) {
                if (attribute.values[0].value[0] == "No") {
                  product.orderable = false;
                }
              }
            }
          });
        }

        if (productVariantPrices.length > 1 && productVariantCompareAtPrices.length > 1) {
          product.variantsCount = productVariantCompareAtPrices.length;
        }

        try {
          prices = getMinPrice(
            productVariantPrices,
            productVariantCompareAtPrices
          );
          if (prices) {
            product.sellingPrice = prices.sellingPrice.value[0];
            product.price = prices.price.value[0];
          }
          // console.log(prices);
        } catch (error) {
          console.log(error);
        }
      });

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      payload.minQueryLength = 1;
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
    function (data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      let x = document.querySelector(".wizzy-body-end-wrapper");
      if (
        x &&
        typeof data.isForDefault !== "undefined" &&
        data.isForDefault === true
      ) {
        x.classList.add("wizzy-view-more-hide");
      } else if (x && x.classList.contains("wizzy-view-more-hide")) {
        x.classList.remove("wizzy-view-more-hide");
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")

      if (payload.sort) {
        if (payload.sort.length == 1 && payload.sort[0].field === "relevance") {
          payload.sort.unshift({
            field: "product_Orderable_tags",
            order: "desc",
          });

          payload.sort.push({
            field: "sellingPrice",
            order: "asc",
            isForParent: false,
            isForVariation: true
          });
        }
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");

      if (payload.filters.sort && payload.filters.sort.length === 1) {
        const sortCriteria = payload.filters.sort[0];
        if (sortCriteria.field === "sellingPrice") {
          console.log("Sorting canceled.");
          payload.filters.showOOSProductsInOrder = "true";
        }
      }

      if (payload.filters.sort && payload.filters.sort[0].field === "relevance") {
          payload.filters.sort.push({
            field: "sellingPrice",
            order: "asc",
            isForParent: false,
            isForVariation: true
          });
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      console.log(data, " <= VIEW_RENDERED");

      const tooltips = document.querySelectorAll(".noUi-tooltip");
      if (tooltips) {
        tooltips.forEach((tooltip) => {
          const text = tooltip.textContent;
          const numericValue = Math.floor(
            parseFloat(text.replace(/[^\d.]/g, ""))
          );
          tooltip.textContent = numericValue.toString();
        });
      }

      const tooltipsGen = document.querySelectorAll(".noUi-value-large");
      if (tooltipsGen) {
        tooltipsGen.forEach((tooltip) => {
          const text = tooltip.textContent;
          const numericValue = Math.floor(
            parseFloat(text.replace(/[^\d.]/g, ""))
          );
          tooltip.textContent = numericValue.toString();
        });
      }

      ////////////////////////////////////
      const noItems = document.querySelectorAll(
        '.wizzy-facet-list-item[data-term="No"]'
      );
      if (noItems.length > 0) {
        noItems.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.textContent = "Non";
          }
        });
      }

      const yesItems = document.querySelectorAll(
        '.wizzy-facet-list-item[data-term="Yes"]'
      );
      if (yesItems.length > 0) {
        yesItems.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.textContent = "Oui";
          }
        });
      }

      ////////////////////////////////////////
      const noItemsTwo = document.querySelectorAll(
        '.wizzy-selected-facet-list-item[data-term="No"]'
      );
      if (noItemsTwo.length > 0) {
        noItemsTwo.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.innerHTML = label.innerHTML.replace("No", "Non");
          }
        });
      }

      const yesItemsTwo = document.querySelectorAll(
        '.wizzy-selected-facet-list-item[data-term="Yes"]'
      );
      if (yesItemsTwo.length > 0) {
        yesItemsTwo.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.innerHTML = label.innerHTML.replace("Yes", "Oui");
          }
        });
      }

      if (document.documentElement.clientWidth > 768) {
        const summaryElement = document.querySelector(
          ".wizzy-search-summary-container .wizzy-summary-head"
        );
        const summaryText = summaryElement.innerHTML;
        const newSummaryElement = document.querySelector(
          ".wiz-summary-new .wizzy-summary-info"
        );
        newSummaryElement.innerHTML = summaryText;
        summaryElement.parentElement.style.display = "none"; // Hiding the parent div
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      ////////////////////////////////////
      const noItems = document.querySelectorAll(
        '.wizzy-facet-list-item[data-term="No"]'
      );
      if (noItems.length > 0) {
        noItems.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.textContent = "Non";
          }
        });
      }

      const yesItems = document.querySelectorAll(
        '.wizzy-facet-list-item[data-term="Yes"]'
      );
      if (yesItems.length > 0) {
        yesItems.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.textContent = "Oui";
          }
        });
      }

      ////////////////////////////////////////
      const noItemsTwo = document.querySelectorAll(
        '.wizzy-selected-facet-list-item[data-term="No"]'
      );
      if (noItemsTwo.length > 0) {
        noItemsTwo.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.innerHTML = label.innerHTML.replace("No", "Non");
          }
        });
      }

      const yesItemsTwo = document.querySelectorAll(
        '.wizzy-selected-facet-list-item[data-term="Yes"]'
      );
      if (yesItemsTwo.length > 0) {
        yesItemsTwo.forEach((item) => {
          const label = item.querySelector(".facet-item-label-value");
          if (label) {
            label.innerHTML = label.innerHTML.replace("Yes", "Oui");
          }
        });
      }

      if (document.documentElement.clientWidth > 768) {
        const summaryElement = document.querySelector(
          ".wizzy-search-summary-container .wizzy-summary-head"
        );
        const summaryText = summaryElement.innerHTML;
        const newSummaryElement = document.querySelector(
          ".wiz-summary-new .wizzy-summary-info"
        );
        newSummaryElement.innerHTML = summaryText;
        summaryElement.parentElement.style.display = "none"; // Hiding the parent div
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log(payload,"BEFORE_RENDER_RESULTS");

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};

////// MUTATION OBSERVER ///////////////////////////////////////////////////////////////////

function setupAutocompletePositioning() {
  const inputElement = document.querySelector(".wizzy-search-input");
  const autocompleteWrapper = document.querySelector(
    ".wizzy-autocomplete-wrapper"
  );

  if (!inputElement || !autocompleteWrapper) {
    return;
  }

  function updateAutocompletePosition() {
    const inputRect = inputElement.getBoundingClientRect();

    autocompleteWrapper.style.position = "absolute"; // Ensure the wrapper is positioned absolutely
    autocompleteWrapper.style.top = `${inputRect.bottom + window.scrollY}px`; // Position below the input
    autocompleteWrapper.style.left = `${inputRect.left + window.scrollX}px`; // Align with input
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "attributes" || mutation.type === "childList") {
        updateAutocompletePosition();
      }
    });
  });

  observer.observe(inputElement, {
    attributes: true,
    childList: true,
    subtree: true,
  });

  updateAutocompletePosition();
}

const globalObserver = new MutationObserver(() => {
  setupAutocompletePositioning();
});

globalObserver.observe(document.body, {
  childList: true,
  subtree: true,
});

setupAutocompletePositioning();
